/* script */










































































import Vue, { PropType } from 'vue'
import $ from 'jquery'
import { AxiosResponse } from 'axios'
import client from '../lib/axiosClient'
import { sellersBusinessPath, sellersBulkDealsPath } from '../lib/rails-routes'
import BusinessToaRow from '../components/BusinessToaRow.vue'
import BusinessToaSearchModalButton from '../components/BusinessToaSearchModalButton.vue'
import BusinessToaMessageFormModalButton from '../components/BusinessToaMessageFormModalButton.vue'
import SelectAllButton from '../components/SelectAllButton.vue'
import LoadMoreButton from '../components/LoadMoreButton.vue'
import { Toa, Business } from '../types/index'
import ListCount from '../components/ListCount.vue'
import { deleteLikeToa, postLikeToa } from '../lib/api/likeToa'

const __vue_script__ = Vue.extend({
  components: {
    BusinessToaRow,
    BusinessToaSearchModalButton,
    BusinessToaMessageFormModalButton,
    ListCount,
    LoadMoreButton,
    SelectAllButton,
  },
  props: {
    business: {
      type: Object as PropType<Business>,
      required: true,
    },
    nextBusiness: {
      type: Object as PropType<Business>,
      required: false,
      default: null,
    },
    initialMessageBody: {
      type: String,
      default: '',
    },
    initialTotalCount: {
      type: Number,
      default: 0,
    },
    initialToas: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      allToaSelected: false,
      errorDeals: [],
      totalCount: this.initialTotalCount,
      searchUrl: null,
      toas: this.initialToas,
      currentPage: 1,
      selectedToas: [],
      messageBody: this.initialMessageBody,
      messageFile: null,
      loading: false,
      messageSubmitted: false,
      formModalShown: false,
      toaUrl: `/sellers/businesses/${this.business.id}/terms_of_acquisitions.json`,
    }
  },
  computed: {
    hasSelectedToas(): boolean {
      return this.selectedToas.length > 0
    },
    toasCount(): number {
      return this.toas.length
    },
    selectedToasCount(): number {
      return this.selectedToas.length
    },
    hasNextToas(): boolean {
      return this.toas.length < this.totalCount
    },
    fetchUrl(): string {
      if (this.searchUrl === null) {
        return `${this.toaUrl}?page=${this.currentPage}`
      }
      return `${this.searchUrl}&page=${this.currentPage}`
    },
    normalUrl(): string {
      return `${sellersBusinessPath({ id: this.business.id })}#business-toas`
    },
    shouldShowToas(): boolean {
      if (this.toas.length > 0) return true
      if (this.searchUrl !== null) return true

      return this.messageSubmitted
    },
  },
  methods: {
    isSelectedToa(toaId: number): boolean {
      return this.selectedToas.findIndex((id) => id === toaId) >= 0
    },
    fetchNext(): void {
      this.currentPage += 1
      this.loading = true
      $.getJSON(this.fetchUrl)
        .done((response) => {
          if (response.items.length > 0) {
            this.toas = this.toas.concat(response.items)
          }
        })
        .always(() => (this.loading = false))
    },
    onToasSearched(toas, searchUrl): void {
      this.toas = toas.items
      this.totalCount = toas.total_count
      this.currentPage = 1
      this.searchUrl = searchUrl
      this.selectedToas = []
    },
    toggleToa(event, toaId: number): void {
      if (this.selectedToas.includes(toaId)) {
        this.selectedToas = this.selectedToas.filter((id) => id !== toaId)
      } else {
        this.selectedToas.push(toaId)
      }
    },
    toggleAllSelect(val: boolean): void {
      this.allToaSelected = val
      if (val) {
        this.selectedToas = this.toas.map((toa) => toa.id)
      } else {
        this.selectedToas = []
      }
    },
    async likeClicked(toa: Toa): Promise<void> {
      let res: AxiosResponse<void>
      if (toa.liked) {
        res = await deleteLikeToa(toa)
      } else {
        res = await postLikeToa(toa)
      }
      const index = this.toas.findIndex((t) => t.id === toa.id)
      this.toas = [...this.toas.slice(0, index), res.data, ...this.toas.slice(index + 1)]
    },

    async onMessageSubmitted({ formData, callback, errorCallback }): Promise<void> {
      let response: AxiosResponse
      try {
        response = await client.post(sellersBulkDealsPath({ format: 'json' }), formData)
      } catch (error) {
        errorCallback(error.response?.data?.errors?.join('\n') ?? '一括紹介に失敗しました')
        return
      }
      this.toas = this.toas.filter((toa) => !response.data.terms_of_acquisition_ids.includes(toa.id))
      this.totalCount = this.totalCount - response.data.terms_of_acquisition_ids.length
      this.messageSubmitted = true
      this.errorDeals = response.data.deals.filter((deal) => Object.values(deal.errors).length > 0)
      callback()
    },
  },
})

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr"),
    _vm._v(" "),
    _c("h3", { staticClass: "h5 mb-3" }, [_vm._v("買収ニーズ候補")]),
    _vm._v(" "),
    _vm.shouldShowToas
      ? _c(
          "div",
          [
            _c("h4", [_vm._v(_vm._s(_vm.business.title))]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _c(
                  "b-button-toolbar",
                  [
                    _c("business-toa-message-form-modal-button", {
                      attrs: {
                        "toa-ids": _vm.selectedToas,
                        "selected-toas-count": _vm.selectedToasCount,
                        "initial-message-body": _vm.initialMessageBody,
                        disabled: !_vm.hasSelectedToas,
                        business: _vm.business,
                        "next-business": _vm.nextBusiness,
                        "error-deals": _vm.errorDeals,
                      },
                      on: { onMessageSubmitted: _vm.onMessageSubmitted },
                    }),
                    _vm._v(" "),
                    _c("business-toa-search-modal-button", {
                      attrs: {
                        "has-selected-toas": _vm.hasSelectedToas,
                        "base-search-url": _vm.toaUrl,
                        business: _vm.business,
                      },
                      on: { "change:toas": _vm.onToasSearched },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "text-muted" },
              [
                _c(
                  "b-col",
                  { staticClass: "total_count", attrs: { md: "6" } },
                  [
                    _c("ListCount", {
                      attrs: {
                        "total-count": _vm.totalCount,
                        "displayed-count": _vm.toasCount,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-md-right", attrs: { md: "6" } },
                  [_vm._v("※すでに本案件を紹介済みのニーズは表示されません")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("select-all-button", {
              staticClass: "mt-3",
              on: { input: _vm.toggleAllSelect },
              model: {
                value: _vm.allToaSelected,
                callback: function ($$v) {
                  _vm.allToaSelected = $$v
                },
                expression: "allToaSelected",
              },
            }),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table toa-table" },
              _vm._l(_vm.toas, function (toa) {
                return _c("BusinessToaRow", {
                  key: toa.id,
                  attrs: {
                    toa: toa,
                    selected: _vm.isSelectedToa(toa.id),
                    "show-deal-sent-info": false,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleToa($event, toa.id)
                    },
                    "change:checkbox": function ($event) {
                      return _vm.toggleToa($event, toa.id)
                    },
                    likeClicked: _vm.likeClicked,
                  },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("business-toa-message-form-modal-button", {
              attrs: {
                "toa-ids": _vm.selectedToas,
                "selected-toas-count": _vm.selectedToasCount,
                "initial-message-body": _vm.initialMessageBody,
                disabled: !_vm.hasSelectedToas,
                business: _vm.business,
                "next-business": _vm.nextBusiness,
                "error-deals": _vm.errorDeals,
              },
              on: { onMessageSubmitted: _vm.onMessageSubmitted },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("LoadMoreButton", {
                  attrs: {
                    "has-next": _vm.hasNextToas,
                    loading: _vm.loading,
                    variant: "outline-primary",
                  },
                  on: { click: _vm.fetchNext },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _c("div", [
          _c("div", { staticClass: "alert alert-warning" }, [
            _vm._v(
              "\n      現在、条件にマッチする未紹介の買収ニーズはありません。\n    "
            ),
          ]),
        ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2f61537f_0", { source: ".toa-table[data-v-2f61537f] {\n  width: 100%;\n  margin-top: 10px;\n}\n.toa-table tr[data-v-2f61537f]:hover {\n  cursor: pointer;\n}\n\n/*# sourceMappingURL=BusinessToaRecommendations.vue.map */", map: {"version":3,"sources":["app/javascript/src/containers/BusinessToaRecommendations.vue","BusinessToaRecommendations.vue"],"names":[],"mappings":"AAyOA;EACA,WAAA;EACA,gBAAA;ACxOA;AD0OA;EACA,eAAA;ACvOA;;AAEA,yDAAyD","file":"BusinessToaRecommendations.vue","sourcesContent":["<template>\n  <div>\n    <hr />\n    <h3 class=\"h5 mb-3\">買収ニーズ候補</h3>\n    <div v-if=\"shouldShowToas\">\n      <h4>{{ business.title }}</h4>\n      <div class=\"d-flex justify-content-between align-items-center\">\n        <b-button-toolbar>\n          <business-toa-message-form-modal-button\n            :toa-ids=\"selectedToas\"\n            :selected-toas-count=\"selectedToasCount\"\n            :initial-message-body=\"initialMessageBody\"\n            :disabled=\"!hasSelectedToas\"\n            :business=\"business\"\n            :next-business=\"nextBusiness\"\n            :error-deals=\"errorDeals\"\n            @onMessageSubmitted=\"onMessageSubmitted\"\n          />\n          <business-toa-search-modal-button\n            :has-selected-toas=\"hasSelectedToas\"\n            :base-search-url=\"toaUrl\"\n            :business=\"business\"\n            @change:toas=\"onToasSearched\"\n          />\n        </b-button-toolbar>\n      </div>\n\n      <b-row class=\"text-muted\">\n        <b-col md=\"6\" class=\"total_count\">\n          <ListCount :total-count=\"totalCount\" :displayed-count=\"toasCount\" />\n        </b-col>\n        <b-col md=\"6\" class=\"text-md-right\">※すでに本案件を紹介済みのニーズは表示されません</b-col>\n      </b-row>\n      <select-all-button v-model=\"allToaSelected\" class=\"mt-3\" @input=\"toggleAllSelect\" />\n      <table class=\"table toa-table\">\n        <BusinessToaRow\n          v-for=\"toa in toas\"\n          :key=\"toa.id\"\n          :toa=\"toa\"\n          :selected=\"isSelectedToa(toa.id)\"\n          :show-deal-sent-info=\"false\"\n          @click=\"toggleToa($event, toa.id)\"\n          @change:checkbox=\"toggleToa($event, toa.id)\"\n          @likeClicked=\"likeClicked\"\n        />\n      </table>\n      <business-toa-message-form-modal-button\n        :toa-ids=\"selectedToas\"\n        :selected-toas-count=\"selectedToasCount\"\n        :initial-message-body=\"initialMessageBody\"\n        :disabled=\"!hasSelectedToas\"\n        :business=\"business\"\n        :next-business=\"nextBusiness\"\n        :error-deals=\"errorDeals\"\n        @onMessageSubmitted=\"onMessageSubmitted\"\n      />\n      <div class=\"text-center\">\n        <LoadMoreButton\n          :has-next=\"hasNextToas\"\n          :loading=\"loading\"\n          variant=\"outline-primary\"\n          @click=\"fetchNext\"\n        />\n      </div>\n    </div>\n    <div v-else>\n      <div class=\"alert alert-warning\">\n        現在、条件にマッチする未紹介の買収ニーズはありません。\n      </div>\n    </div>\n  </div>\n</template>\n\n<script lang=\"ts\">\nimport Vue, { PropType } from 'vue'\nimport $ from 'jquery'\nimport { AxiosResponse } from 'axios'\nimport client from '../lib/axiosClient'\nimport { sellersBusinessPath, sellersBulkDealsPath } from '../lib/rails-routes'\nimport BusinessToaRow from '../components/BusinessToaRow.vue'\nimport BusinessToaSearchModalButton from '../components/BusinessToaSearchModalButton.vue'\nimport BusinessToaMessageFormModalButton from '../components/BusinessToaMessageFormModalButton.vue'\nimport SelectAllButton from '../components/SelectAllButton.vue'\nimport LoadMoreButton from '../components/LoadMoreButton.vue'\nimport { Toa, Business } from '../types/index'\nimport ListCount from '../components/ListCount.vue'\nimport { deleteLikeToa, postLikeToa } from '../lib/api/likeToa'\n\nexport default Vue.extend({\n  components: {\n    BusinessToaRow,\n    BusinessToaSearchModalButton,\n    BusinessToaMessageFormModalButton,\n    ListCount,\n    LoadMoreButton,\n    SelectAllButton,\n  },\n  props: {\n    business: {\n      type: Object as PropType<Business>,\n      required: true,\n    },\n    nextBusiness: {\n      type: Object as PropType<Business>,\n      required: false,\n      default: null,\n    },\n    initialMessageBody: {\n      type: String,\n      default: '',\n    },\n    initialTotalCount: {\n      type: Number,\n      default: 0,\n    },\n    initialToas: {\n      type: Array,\n      required: true,\n    },\n  },\n  data() {\n    return {\n      allToaSelected: false,\n      errorDeals: [],\n      totalCount: this.initialTotalCount,\n      searchUrl: null,\n      toas: this.initialToas,\n      currentPage: 1,\n      selectedToas: [],\n      messageBody: this.initialMessageBody,\n      messageFile: null,\n      loading: false,\n      messageSubmitted: false,\n      formModalShown: false,\n      toaUrl: `/sellers/businesses/${this.business.id}/terms_of_acquisitions.json`,\n    }\n  },\n  computed: {\n    hasSelectedToas(): boolean {\n      return this.selectedToas.length > 0\n    },\n    toasCount(): number {\n      return this.toas.length\n    },\n    selectedToasCount(): number {\n      return this.selectedToas.length\n    },\n    hasNextToas(): boolean {\n      return this.toas.length < this.totalCount\n    },\n    fetchUrl(): string {\n      if (this.searchUrl === null) {\n        return `${this.toaUrl}?page=${this.currentPage}`\n      }\n      return `${this.searchUrl}&page=${this.currentPage}`\n    },\n    normalUrl(): string {\n      return `${sellersBusinessPath({ id: this.business.id })}#business-toas`\n    },\n    shouldShowToas(): boolean {\n      if (this.toas.length > 0) return true\n      if (this.searchUrl !== null) return true\n\n      return this.messageSubmitted\n    },\n  },\n  methods: {\n    isSelectedToa(toaId: number): boolean {\n      return this.selectedToas.findIndex((id) => id === toaId) >= 0\n    },\n    fetchNext(): void {\n      this.currentPage += 1\n      this.loading = true\n      $.getJSON(this.fetchUrl)\n        .done((response) => {\n          if (response.items.length > 0) {\n            this.toas = this.toas.concat(response.items)\n          }\n        })\n        .always(() => (this.loading = false))\n    },\n    onToasSearched(toas, searchUrl): void {\n      this.toas = toas.items\n      this.totalCount = toas.total_count\n      this.currentPage = 1\n      this.searchUrl = searchUrl\n      this.selectedToas = []\n    },\n    toggleToa(event, toaId: number): void {\n      if (this.selectedToas.includes(toaId)) {\n        this.selectedToas = this.selectedToas.filter((id) => id !== toaId)\n      } else {\n        this.selectedToas.push(toaId)\n      }\n    },\n    toggleAllSelect(val: boolean): void {\n      this.allToaSelected = val\n      if (val) {\n        this.selectedToas = this.toas.map((toa) => toa.id)\n      } else {\n        this.selectedToas = []\n      }\n    },\n    async likeClicked(toa: Toa): Promise<void> {\n      let res: AxiosResponse<void>\n      if (toa.liked) {\n        res = await deleteLikeToa(toa)\n      } else {\n        res = await postLikeToa(toa)\n      }\n      const index = this.toas.findIndex((t) => t.id === toa.id)\n      this.toas = [...this.toas.slice(0, index), res.data, ...this.toas.slice(index + 1)]\n    },\n\n    async onMessageSubmitted({ formData, callback, errorCallback }): Promise<void> {\n      let response: AxiosResponse\n      try {\n        response = await client.post(sellersBulkDealsPath({ format: 'json' }), formData)\n      } catch (error) {\n        errorCallback(error.response?.data?.errors?.join('\\n') ?? '一括紹介に失敗しました')\n        return\n      }\n      this.toas = this.toas.filter((toa) => !response.data.terms_of_acquisition_ids.includes(toa.id))\n      this.totalCount = this.totalCount - response.data.terms_of_acquisition_ids.length\n      this.messageSubmitted = true\n      this.errorDeals = response.data.deals.filter((deal) => Object.values(deal.errors).length > 0)\n      callback()\n    },\n  },\n})\n</script>\n\n<style scoped lang=\"scss\">\n .toa-table {\n     width: 100%;\n     margin-top: 10px;\n }\n .toa-table tr:hover {\n     cursor: pointer;\n }\n</style>\n",".toa-table {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.toa-table tr:hover {\n  cursor: pointer;\n}\n\n/*# sourceMappingURL=BusinessToaRecommendations.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-2f61537f"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/src/containers/BusinessToaRecommendations.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__